import {
  Box,
  Container,
  Typography,
  Grid,
  Link,
  IconButton,
} from "@mui/material";
import { Facebook, Instagram, Twitter } from "@mui/icons-material";

// Footer component to display site information, quick links, and social media icons
const Footer = () => {
  return (
    <Container>
      <Box sx={{ backgroundColor: "#23262D", color: "white", py: 4, mt: 5 }}>
        <Container maxWidth="lg">
          <Grid container spacing={3}>
            {/* Store Name and Developer Info */}
            <Grid item xs={12} sm={4}>
              <Typography variant="h6" fontWeight="bold" color="primary">
                Hasan Store
              </Typography>
              <Typography
                variant="body2"
                sx={{ mt: 1, color: "#A5AAB5", width: "85%" }}
              >
                This Web Application is completely designed and developed by
                Hasan Shehada
              </Typography>
            </Grid>

            {/* Quick Links Section */}
            <Grid item xs={12} sm={4}>
              <Typography variant="h6" fontWeight="bold" color="primary">
                Quick links
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  mt: 1,
                }}
              >
                <Link href="/" color="inherit" underline="hover">
                  <Typography sx={{ fontSize: "14px" }}>Home</Typography>
                </Link>
                <Link href="/#products" color="inherit" underline="hover">
                  <Typography sx={{ fontSize: "14px" }}>Products</Typography>
                </Link>
              </Box>
            </Grid>

            {/* Social Media Section */}
            <Grid item xs={12} sm={4}>
              <Typography variant="h6" fontWeight="bold" color="primary">
                Follow us on
              </Typography>
              <Box sx={{ mt: 1 }}>
                <IconButton color="inherit">
                  <Facebook />
                </IconButton>
                <IconButton color="inherit">
                  <Instagram />
                </IconButton>
                <IconButton color="inherit">
                  <Twitter />
                </IconButton>
              </Box>
            </Grid>
          </Grid>

          {/* Footer Copyright Text */}
          <Box sx={{ textAlign: "center", color: "#A5AAB5", mt: "50px" }}>
            <Typography variant="body2">
              &copy; {new Date().getFullYear()} Hasan Store - All rights
              reserved.
            </Typography>
          </Box>
        </Container>
      </Box>
    </Container>
  );
};

export default Footer;
